import './AddressAutocomplete.scss'

import React, { Component } from 'react'
import Script from 'react-load-script'
import PlacesAutocomplete from 'react-places-autocomplete'

import { GOOGLE_API_KEY } from 'common/constants'


// NOTE - this is an opcity wrapper around - https://github.com/kenny-hibino/react-places-autocomplete
export default class AddressAutocomplete extends Component {
  constructor(props) {
    super(props)
    this.state = { loaded: false }
  }

  render() {

    const AutocompleteItem = ({ formattedSuggestion }) => (
      <div className="AddressAutocomplete__suggestion-item">
        <i className='fa fa-map-marker AddressAutocomplete__suggestion-icon'/>
        <strong>{formattedSuggestion.mainText}</strong>{' '}
        <small className="text-muted">{formattedSuggestion.secondaryText}</small>
      </div>)

    let addressStyles = {
      autocompleteContainer: {
        zIndex: '100'
      }
    }
    if(this.props.styles) {
      addressStyles = {
        ...addressStyles,
        ...this.props.styles
      }
    }

    return(
      <div>
        { this.state.loaded ?
          <PlacesAutocomplete
            inputProps={this.props.inputProps}
            styles={addressStyles}
            autocompleteItem={AutocompleteItem}
            googleLogo={false}
            options={this.props.searchOptions}
            onError={this.props.onError}
          /> :
          <Script
            url={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`}
            onLoad={()=>this.setState({ loaded: true })}
          />
        }
      </div>
    )
  }
}
